<template>
  <v-container fluid :class="$style['container']">
    <v-overlay :value="processing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <ToolBar>
      <template v-slot:left>
        <Breadcrumb :items="breadcrumbs" />
        <div class="d-flex align-center">
          <v-btn
            v-if="!disabledAddButton"
            class="mx-1"
            @click="moveToCreate"
            small
            color="primary"
            max-height="36"
            depressed
          >
            <v-icon left>mdi-plus-box</v-icon>新規登録
          </v-btn>
        </div>
        <div class="d-flex align-center">
        </div>
      </template>
      <template v-slot:middleRight>
        <div class="d-flex align-center">
          <template v-if="resourceName === 'news' || resourceName === 'reminders'">
            <CButtonGroup>
              <CButton
                      color="success"
                      @click="moveToNews"
                      v-if="resourceName !== 'news'">
                お知らせ管理</CButton>
            </CButtonGroup>
            <v-btn
                  class="mx-1"
                  small
                  color="success"
                  max-height="36"
                  depressed
                  @click="moveToReminders"
                  v-if="resourceName !== 'reminders'"
            >
              アンケートと商品レビュー催促管理
            </v-btn>
          </template>
          <template v-if="resourceName === 'recipes'">
            <v-btn
                  class="mx-1"
                  small
                  color="success"
                  max-height="36"
                  depressed
                  @click="openDialog('recipes')"
                  v-if="!disableImport"
            >
              レシピ一括登録
            </v-btn>
            <v-btn
                  class="mx-1"
                  small
                  color="success"
                  max-height="36"
                  depressed
                  @click="moveToDownload('recipes')"
            >
              レシピ一括ダウンロード
            </v-btn>
          </template>
          <template v-if="resourceName === 'products'">
            <v-btn
                  class="mx-1"
                  small
                  color="success"
                  max-height="36"
                  depressed
                  @click="openDialog('products')"
                  v-if="!disableImport"
            >
              商品一括登録
            </v-btn>
            <v-btn
                  class="mx-1"
                  small
                  color="success"
                  max-height="36"
                  depressed
                  @click="moveToDownload('products')"
            >
              商品一括ダウンロード
            </v-btn>
          </template>
          <template v-if="resourceName === 'masters'">
            <v-btn
                  class="mx-1"
                  small
                  color="success"
                  max-height="36"
                  depressed
                  @click="openMainFlgDialog()"
            >
              メインフラグ設定
            </v-btn>
            <v-btn
                  class="mx-1"
                  small
                  color="success"
                  max-height="36"
                  depressed
                  @click="openDialog('masters')"
            >
              一括登録csvインポート
            </v-btn>
          </template>
          <v-btn
            v-if="showAutoReplyDialog"
            class="mx-1"
            @click="openAutoReplyDialog"
            small
            color="success"
            max-height="36"
            depressed
          >
            自動返信設定
          </v-btn>
        </div>
      </template>
      <template v-slot:right>
        <div class="d-flex align-center" style="margin: 0 10px">
          <span v-if="!disabledTotal" style="font-size: 19px;">{{ total }}件</span>
          <span v-if="resourceName === 'recipes' && recipeNum !== null && maxRecipeNum > 0" style="font-size: 15px;">(公開数{{recipeNum}}件)</span>
          <span v-if="resourceName === 'message'" style="font-size: 15px;">(未読数{{notRead}}件)</span>
          <span v-if="resourceName === 'products' && productNum !== null" style="font-size: 15px;">(公開数{{productNum}}件)</span>
        </div>
        <div v-if="!disabledPagination" class="d-flex align-center">
          <CSelect
                  style="padding: 0; width: 210px; margin-bottom: 0;"
                  :options="perPageOptions"
                  :value="perPage"
                  @update:value="onChangePerPage"
                  label="1ページあたり:"
                  :horizontal="{ label: 'sm-7', input: 'sm-5'}"
          >
          </CSelect>
        </div>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-if="!disabledFilterButton" icon v-on="on" @click.stop="onFilter">
              <v-badge :value="filtered" dot top color="red" offset-x="8" offset-y="8">
                <v-icon>mdi-filter-outline</v-icon>
              </v-badge>
            </v-btn>
          </template>
          <span>フィルタ</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon @click="onRefresh" v-on="on">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>再読込</span>
        </v-tooltip>
      </template>
    </ToolBar>
    <CTabs 
      v-if="!disableTab"
      variant="tabs"
      :active-tab="0"
      @update:activeTab="activeTab"
    >
      <CTab title="メーカー"></CTab>
      <CTab title="ユーザー"></CTab>
    </CTabs>
    <div :class="$style['container-content']">
      <v-content class="app-content">
        <v-layout column fill-height>
          <v-flex grow>
            <div :class="disableTab ? $style['main-content'] : $style['main-tab-content']" class="table-responsive">
          <!--
          <v-data-table
            :headers="columnsForTable"
            :items="entities"
            :items-per-page="perPage"
            :loading="loading"
            loading-text="読込中..."
            no-data-text="データがありません"
            fixed-header
            hide-default-footer
            @update:options="sortBy"
          >
          </v-data-table>-->
              <CDataTable
                  :items="entities"
                  :fields="columnsForTable"
                  hover
                  :loading="loading"
                  :clickableRows="true"
                  @row-clicked="moveToShow"
                  @update:sorter-value="sortBy"
                  :sorter='{ external: true, resetable: false }'
                  :class="$style['main-table']"
                  :noItemsView='{ noResults: "データが存在しません", noItems: loading ? "読込中" : "データが存在しません" }'
          >

            <template #publish="{item}">
              <td>
                <span >
                  {{item.publish === 1 ? "公開" :　
                      ( item.publish === 2 ? "非公開予約:" + item.apply_at : (
                            item.publish === 3 ? "公開予約:" + item.apply_at
                                : "非公開"))}}
                </span>
              </td>
            </template>
                <template #published="{item}">
                  <td>
                <span >
                  {{item.published === 1 ? "公開" : "非公開"}}
                </span>
                  </td>
                </template>
            <template #for_paid_user="{item}">
              <td>
            <span >
              {{item.for_paid_user === 1 ? "有料会員向け" : "全会員向け"}}
            </span>
              </td>
            </template>
            <template #image="{item}">
              <td>
                <div><img style="max-width: 100px;max-height: 100px" :src="item.image" /></div>
              </td>
            </template>
            <template #status="{ item }">
              <td>
                <span >
              {{ statusName(item.status) }}
                </span>
              </td>
            </template>
            <template #user_status="{ item }">
                  <td>
                <span >
              {{ userStatusName(item.user_status) }}
                </span>
                  </td>
            </template>
            <template #inquiry_type="{ item }">
                  <td>
                <span >
              {{ inquiryTypeName(item.inquiry_type) }}
                </span>
                  </td>
            </template>
            <template #checkbox-header="{item, index}">
                <CInputCheckbox
                        :checked="allSelected"
                        @update:checked="selectAll"
                        @click.stop=""
                        style="margin-top: -13px;"
                        size="lg"
                >
                </CInputCheckbox>
            </template>
            <template #checkbox="{item, index}">
              <td class="py-2">
                <CInputCheckbox
                        v-if="showCheckBox(item)"
                        :checked="selected.findIndex(selectItem => selectItem[pk] === item[pk]) >= 0"
                        :value="item[pk]"
                        @update:checked="onCheck(item)"
                        @click.stop=""
                        size="lg"
                >
                </CInputCheckbox>
              </td>
            </template>
            <template #free_text="{item}">
              <td>
                <CButton color="success" @click.stop="openEditFreeText(item)">
                  フリー欄を編集する
                </CButton>
              </td>
            </template>
            <template #condiments="{item}">
              <td>
                <CButton color="success"
                  @click.stop="openCondimentsModal(item.recipe_id)">
                  紐付き商品一覧
                </CButton>
              </td>
            </template>
            <template #statistics="{item}">
              <td>
                <CButton color="success"
                  v-if="showStatisticsButton(item)"
                  @click.stop="moveToShowStatistics(item)">
                  集計結果
                </CButton>
              </td>
            </template>
            <template #conditions="{item}">
              <td>
                <CButton color="success"
                  @click.stop="openConditionsModal(item.push_advertisments_id)">
                  絞り込み条件を表示
                </CButton>
              </td>
            </template>
            <template #maker_id="{item}">
              <td>
            <span >
              {{resourceName !== 'makers' ? optionName('common/makers', item.maker_id) : item.maker_id}}
            </span>
              </td>
            </template>
            <template #last_checked="{item}">
              <td>
                <template v-if="!item.last_checked">
                  <CBadge color="danger" shape="pill">未読</CBadge>
                </template>
              </td>
            </template>
                <template #duplicated="{item}">
                  <td>
                    <template v-if="item.duplicated === 1">
                      <CBadge color="danger" shape="pill">重複</CBadge>
                    </template>
                  </td>
                </template>
            <template #latest_message="{item}">
                  <td>
            <span >
              <div v-if="item.latest_message_type == 2">
                <img style="max-width: 100px;max-height: 100px" :src="item.latest_message" />
              </div>
              <div v-else>
                {{ item.latest_message }}
              </div>
            </span>
                  </td>
            </template>
                <template #maker_administrator_deleted="{item}">
                  <td>
            <span >
              {{item.maker_administrator_deleted === 0 ? '' : optionName('common/delete_status', item.maker_administrator_deleted)}}
            </span>
                  </td>
                </template>
            <template #user_type="{item}">
              <td>
                <span >
                  {{item.user_type === 1 ? "一般ユーザ" :
                      ( item.user_type === 2 ? "飲食人" : "")}}
                </span>
              </td>
            </template>
            <template #plan_num="{item}">
              <td>
                <span v-if="resourceName === 'makers'">
                  {{optionName('common/plans', item.plan_num) ? optionName('common/plans', item.plan_num) : item.plan_num}}
                </span>
                <span v-else>
                  {{item.plan_num === 1 ? "無料" :
                      ( item.plan_num === 2 ? "有料" : ( item.plan_num === 3 ? "有料(翌月無料化)" : ""))}}
                </span>
              </td>
            </template>
            <template #user_deleted="{item}">
              <td>
                <span >
                  {{item.user_deleted === 0 ? '' : optionName('common/delete_status', item.user_deleted)}}
                </span>
              </td>
            </template>
            <template v-if="resourceName === 'administrators'" #deleted="{item}">
              <td>
                <span >
                  {{item.deleted === 0 ? '' : optionName('common/delete_status', item.deleted)}}
                </span>
              </td>
            </template>
            <template #permission_all="{item}">
              <td>
                <span >
                  {{item.permission_all === 1 ? "○" : ""}}
                </span>
              </td>
            </template>
            <template #permission_maker="{item}">
              <td>
                <span >
                  {{item.permission_maker === 1 ? "閲覧" :
                      ( item.permission_maker === 2 ? "編集" : "")}}
                </span>
              </td>
            </template>
            <template #permission_user="{item}">
              <td>
                <span >
                  {{item.permission_user === 1 ? "閲覧" :
                      ( item.permission_user === 2 ? "編集" : "")}}
                </span>
              </td>
            </template>
                      <template #permission_article="{item}">
              <td>
                <span >
                  {{item.permission_article === 1 ? "閲覧" :
                      ( item.permission_article === 2 ? "編集" : "")}}
                </span>
              </td>
            </template>
            <template #sent="{item}">
              <td>
                <span >
                  {{item.sent === 0 ? "送信予定" :
                      ( item.sent === 1 ? "送信済み" : "")}}
                </span>
              </td>
            </template>
                <template #notification_type="{item}">
                  <td>
                <span >
                  {{item.notification_type === 2 ? "アンケート" :
                      ( item.notification_type === 3 ? "商品レビュー" : "")}}
                </span>
                  </td>
                </template>
                <template #targets="{item}">
                  <td>
                    <CButton color="success"
                             @click.stop="openSendTargetModal(item.id)">
                      送信先ユーザ
                    </CButton>
                  </td>
                </template>
                <template #sample_paid="{item}">
                <td>
                <span >
                  {{item.sample_paid === 1 ? "有償" :
                      ( item.sample_paid === 0 ? "無償" : "")}}
                </span>
                </td>
              </template>
          </CDataTable>
        </div>
          </v-flex>

          <v-flex v-if="!disableEdit" :class="$style['container-footer']">
            <div style="position: absolute; bottom: 16px; left: 20px;">
              <v-btn
                      v-if="showImmediatePublishButton"
                      :disabled="disablePublishButton"
                      class="mx-1"
                      @click="publish(1)"
                      small
                      color="success"
                      max-height="36"
                      depressed
                      :class="$style['control-button']"
              >
                公開
              </v-btn>
              <v-btn
                      v-if="showImmediatePublishButton"
                      :disabled="disableUnPublishButton"
                      class="mx-1"
                      @click="publish(0)"
                      small
                      color="success"
                      max-height="36"
                      depressed
                      :class="$style['control-button']"
              >
                非公開
              </v-btn>
              <v-btn
                      v-if="showPublishButton"
                      :disabled="disablePublishButton"
                      class="mx-1"
                      @click="openPublishModal"
                      small
                      color="success"
                      max-height="36"
                      depressed
                      :class="$style['control-button']"
              >
                公開
              </v-btn>
              <v-btn
                      v-if="showPublishButton"
                      :disabled="disableUnPublishButton"
                      class="mx-1"
                      @click="openUnPublishModal"
                      small
                      color="success"
                      max-height="36"
                      depressed
                      :class="$style['control-button']"
              >
                非公開
              </v-btn>
              <v-btn
                      v-if="showPublishButton"
                      :disabled="disableCancelPublishButton"
                      class="mx-1"
                      @click="cancelPublish"
                      small
                      color="success"
                      max-height="36"
                      depressed
                      :class="$style['control-button']"
              >
                予約取消
              </v-btn>
              <v-btn
                      v-if="showEnableButton"
                      :disabled="disableEnableButton"
                      class="mx-1"
                      @click="enable"
                      small
                      color="success"
                      max-height="36"
                      depressed
                      :class="$style['control-button']"
              >
                有効
              </v-btn>
              <v-btn
                      v-if="showDisableButton"
                      :disabled="disableDisableButton"
                      class="mx-1"
                      @click="disable"
                      small
                      color="error"
                      max-height="36"
                      depressed
                      :class="$style['control-button']"
              >
                無効
              </v-btn>
              <v-btn
                      v-if="showRestoreButton"
                      :disabled="disableRestoreButton"
                      class="mx-1"
                      @click="restore"
                      small
                      color="primary"
                      max-height="36"
                      depressed
                      :class="$style['control-button']"
              >
                復活
              </v-btn>
              <v-btn
                      v-if="showDeleteButton"
                      :disabled="disableDeleteButton"
                      class="mx-1"
                      @click="remove"
                      small
                      color="error"
                      max-height="36"
                      depressed
                      :class="$style['control-button']"
              >
                削除
              </v-btn>
              <v-btn
                      v-if="showShippedButton"
                      :disabled="disableShippedButton"
                      class="mx-1"
                      @click="onShipped"
                      small
                      color="success"
                      max-height="36"
                      depressed
                      :class="$style['control-button']"
              >
                出荷完了
              </v-btn>
              <v-btn
                      v-if="showUnshippedButton"
                      :disabled="disableDeleteButton"
                      class="mx-1"
                      @click="remove"
                      small
                      color="error"
                      max-height="36"
                      depressed
                      :class="$style['control-button-wide']"
              >
                出荷キャンセル
              </v-btn>
              <v-btn
                      v-if="showRemoveShippedButton"
                      :disabled="disableRemoveShippedButton"
                      class="mx-1"
                      @click="onRemoveShipped"
                      small
                      color="error"
                      max-height="36"
                      depressed
                      :class="$style['control-button-wide']"
              >
                出荷済み取り消し
              </v-btn>
              <v-btn
                      v-if="showOngoingInquiryButton"
                      :disabled="disableOngoingInquiryButton"
                      class="mx-1"
                      @click="onOngoingInquiryButton"
                      small
                      color="success"
                      max-height="36"
                      depressed
                      :class="$style['control-button']"
              >
                対応中
              </v-btn>
              <v-btn
                      v-if="showCompleteInquiryButton"
                      :disabled="disableCompleteInquiryButton"
                      class="mx-1"
                      @click="onCompleteInquiryButton"
                      small
                      color="success"
                      max-height="36"
                      depressed
                      :class="$style['control-button']"
              >
                対応済
              </v-btn>
              <v-btn
                v-if="this.resourceName === 'answers'"
                class="mx-1"
                @click="downloadCSV"
                small
                color="success"
                max-height="36"
                depressed
                :class="$style['control-button-wide']"
              >
                CSVダウンロード
              </v-btn>
            </div>

            <CPagination
            v-if="!disabledPagination"
            :class="{ 'hidden-pagination': isHiddenPagination }"
            :pages="pageLength"
            :activePage="currentPage"
            @update:activePage="onChangePage"
            align="center"
            style="margin-top: 5px"
            >
          </CPagination>

          </v-flex>

          </v-layout>
      </v-content>
    </div>
    <FilterModal :resourceName="resourceName" :columns="columns" />
    <PasswordReissueDialog :resourceName="resourceName" />
    <AutoReplySettingDialog v-if="resourceName === 'message'" :resourceName="resourceName" />
    <CModal
          color="success"
          :show.sync="publishModal"
          title="公開状態切替"
  >
    <p>
      公開状態を変更するタイミングを選択してください
    </p>
    <CInputRadioGroup
            style="margin-top: 10px;margin-bottom: 5px"
            :options="[
                { value: false, label: '即時'},
                { value: true, label: '予約'}
              ]"
            v-model="reservePublish"
            @update:checked="onChangeReservePublish"
    >
    </CInputRadioGroup>

    <datepicker :format="DatePickerFormat" :language="ja"
                :class="$style['datepicker']"
                placeholder="日付を選択してください"
                v-if="reservePublish"
                v-model="targetDate"
                :disabled-dates="disableDates"
    ></datepicker>

    <v-btn
            class="mx-1"
            @click="publish(1)"
            small
            color="success"
            max-height="36"
            depressed
            :class="$style['control-button']"
    >
      公開
    </v-btn>
      <template #footer>
        <span></span>
      </template>
  </CModal>
    <CModal
            color="danger"
            :show.sync="unPublishModal"
            title="非公開状態切替"
    >
      <p>
        公開状態を変更するタイミングを選択してください
      </p>
      <CInputRadioGroup
              style="margin-top: 10px;margin-bottom: 5px"
              :options="[
                { value: false, label: '即時'},
                { value: true, label: '予約'}
              ]"
              @update:checked="onChangeReservePublish"
      >
      </CInputRadioGroup>

      <datepicker :format="DatePickerFormat" :language="ja"
                  :class="$style['datepicker']"
                  placeholder="日付を選択してください"
                  v-if="reservePublish"
                  v-model="targetDate"
                  :disabled-dates="disableDates"
      ></datepicker>

      <v-btn
              class="mx-1"
              @click="publish(0)"
              small
              color="error"
              max-height="36"
              depressed
              :class="$style['control-button']"
      >
        非公開
      </v-btn>
      <template #footer>
        <span></span>
      </template>
    </CModal>
    <CModal
            color="success"
            :show.sync="condimentsModal"
            title="紐付き商品一覧"
            hide-footer
    >
      <CDataTable
              :items="condiments"
              :fields="[
                { label: 'システム管理商品ID', key: 'product_id', _style:'min-width:80px' },
                { label: '商品名', key: 'product_name', _style:'min-width:150px;' },
                { label: '状態', key: 'status', _style:'min-width:60px;' }
              ]"
      >
      </CDataTable>
      <template #footer>
        <span></span>
      </template>
    </CModal>
    <FreeTextEditDialog :resourceName="resourceName" />
    <InquiryDetailDialog v-if="resourceName === 'inquiries'" />
    <ConditionsDialog v-if="resourceName === 'push_advertisments'" />
    <SendTargetDialog v-if="resourceName === 'reminders' || resourceName === 'reminder_histories'" />
    <MasterEditDialog
      v-if="resourceName === 'masters'"
      @master-saved="afterDialogSaved"
    />
    <MasterMainFlgEditDialog
      v-if="resourceName === 'masters'"
      @mainflg-saved="afterDialogSaved"
    />
    <PushCreateDialog
      v-if="resourceName === 'push_advertisments'"
      @push-saved="afterDialogSaved"
    />
    <ImportDialog resourceName="import_recipes" />
    <ImportDialog resourceName="import_products" />
    <ImportDialog
      resourceName="import_masters"
      accept=".csv"
      @close-csv-import-dialog="afterDialogSaved"
    />
  </v-container>
</template>

<script>
import ToolBar from "@/components/app/toolbar";
import FilterModal from "@/components/filter-modal";
import utility from "@/utility";
import RemoveAction from "@/components/view/actions/remove";
import DetailAction from "@/components/view/actions/detail";
import Breadcrumb from "@/components/app/breadcrumb";
import PasswordReissueDialog from "@/components/dialogs/password-reissue-dialog";
import AutoReplySettingDialog from "@/components/dialogs/autoreply-setting-dialog";
import FreeTextEditDialog from "@/components/dialogs/freetext-edit-dialog";
import InquiryDetailDialog from "@/components/dialogs/inquiry-detail-dialog";
import ConditionsDialog from "@/components/dialogs/conditions-dialog";
import MasterEditDialog from "@/components/dialogs/master-edit-dialog";
import MasterMainFlgEditDialog from "@/components/dialogs/master-mainflg-edit-dialog";
import PushCreateDialog from "@/components/dialogs/push-create-dialog";
import SendTargetDialog from "@/components/dialogs/send-targets-dialog";

import Datepicker from 'vuejs-datepicker'
import ImportDialog from "@/components/dialogs/csv-import-dialog";

//日本語化
import {ja} from 'vuejs-datepicker/dist/locale'
import moment from 'moment';

export default {
  components: {
    ToolBar,
    Breadcrumb,
    RemoveAction,
    DetailAction,
    FilterModal,
    PasswordReissueDialog,
    Datepicker,
    AutoReplySettingDialog,
    FreeTextEditDialog,
    InquiryDetailDialog,
    ConditionsDialog,
    MasterEditDialog,
    MasterMainFlgEditDialog,
    PushCreateDialog,
    ImportDialog,
    SendTargetDialog
  },
  props: {
    resourceName: {
      type: String,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    pk: {
      type: String,
      default: "id"
    },
    disabledAddButton: {
      type: Boolean,
      default: false
    },
    disabledTotal: {
      type: Boolean,
      default: false
    },
    disabledFilterButton: {
      type: Boolean,
      default: true
    },
    disabledPagination: {
      type: Boolean,
      default: false
    },
    disabledCheckbox: {
      type: Boolean,
      default: false
    },
    breadcrumbs: {
      type: Array,
      default: () => []
    },
    disableTab: {
      type: Boolean,
      default: true
    },
    disableEdit: {
      type: Boolean,
      default: false
    },
    disableImport: {
      type: Boolean,
      default: false
    },
    subId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      perPageOptions: [
        { value: 20, label: '20件' },
        { value: 50, label: '50件' },
        { value: 100, label: '100件' }
      ],
      // 公開切り替えモーダル関連
      publishModal: false,
      unPublishModal: false,
      DatePickerFormat: 'yyyy-MM-dd',
      ja:ja,
      targetDate: null,
      reservePublish: false,
      // 紐付き商品一覧関連
      condimentsModal: false,

    }
  },
  computed: {
    disableDates() {
      return {
        to: moment().toDate()
      }
    },
    loading() {
      return this.$store.getters[`${this.resourceName}/list/isLoading`];
    },
    processing() {
      return this.$store.getters[`${this.resourceName}/list/isProcessing`];
    },
    entities() {
      return this.$store.getters[`${this.resourceName}/list/entities`];
    },
    total() {
      return this.$store.getters[`${this.resourceName}/list/total`];
    },
    recipeNum() {
      return this.$store.getters[`${this.resourceName}/list/recipeNum`];
    },
    maxRecipeNum() {
      return this.$store.getters[`${this.resourceName}/list/maxRecipeNum`];
    },
    notRead() {
      return this.$store.getters[`${this.resourceName}/list/notRead`];
    },
    productNum() {
      return this.$store.getters[`${this.resourceName}/list/productNum`];
    },
    currentPage() {
      return this.$store.getters[`${this.resourceName}/list/page`];
    },
    perPage() {
      return this.$store.getters[`${this.resourceName}/list/perPage`];
    },
    pageLength() {
      return this.$store.getters[`${this.resourceName}/list/pageLength`];
    },
    filters() {
      return this.$store.getters["filters/filters"];
    },
    shouldFetch() {
      return this.$store.getters["filters/shouldFetch"];
    },
    filtered() {
      return this.$store.getters["filters/filtered"];
    },
    sort() {
      return this.$store.getters[`${this.resourceName}/list/sort`];
    },
    columnsForTable() {
      let columnFiltered = this.columns.filter(column => {
        return !(column.isProvider && !this.isProvider);
      });

      let columns = columnFiltered.map(column => {
        if(!(column.isProvider && !this.isProvider)) {
          return {
            key: column.value,
            label: column.text,
            filter: column.filter === undefined ? true : column.filter,
            sorter: column.sorter === undefined ? true : column.sorter,
            _style: 'width:' + column.width + ';',
            // filterable  : column.filterable,
            // divider     : true,
            // class       : column.class,
          };
        }
      });

      if(this.resourceName === 'requests'){
        columns.push(
          {
            key: 'free_text',
            label: '',
            _style: 'max-width:100px;',
            sorter: false,
            filter: false
          }
          );
      }

      return this.disabledCheckbox ? columns : [
        {
          key: 'checkbox',
          label: '',
          _style: 'max-width:30px;',
          sorter: false,
          filter: false
        },
        ...columns
      ];
    },
    disablePublishButton(){
      return this.selected.length < 1;
    },
    disableUnPublishButton(){
      return this.selected.length < 1;
    },
    disableCancelPublishButton(){
      if(this.selected.findIndex(item => item['publish'] === 2 || item['publish'] === 3 ) < 0){ return true; }
      return this.selected.length < 1;
    },
    disableEnableButton() {
      return this.selected.length < 1;
    },
    disableDisableButton() {
      return this.selected.length < 1;
    },
    disableDeleteButton(){
      return this.selected.length < 1;
    },
    disableRestoreButton(){
      return this.selected.length < 1;
    },
    disableShippedButton(){
      return this.selected.length < 1;
    },
    disableRemoveShippedButton(){
      return this.selected.length < 1;
    },
    disableOngoingInquiryButton() {
      return this.selected.length < 1;
    },
    disableCompleteInquiryButton(){
      return this.selected.length < 1;
    },
    showPublishButton(){
      if(this.resourceName !== 'recipes' && this.resourceName !== 'products'){
        return false;
      }

      return true;
    },
    showImmediatePublishButton(){
      if(this.resourceName !== 'news' && this.resourceName !== 'topics'){
        return false;
      }

      return true;
    },
    showShippedButton(){
      if(this.resourceName !== 'requests'){
        return false;
      }

      return true;
    },
    showRemoveShippedButton(){
      if(this.resourceName !== 'requests'){
        return false;
      }

      return true;
    },
    showOngoingInquiryButton() {
      if(this.resourceName !== 'inquiries'){
        return false;
      }

      return true;
    },
    showCompleteInquiryButton(){
      if(this.resourceName !== 'inquiries'){
        return false;
      }

      return true;
    },
    showEnableButton(){
      if (this.resourceName !== 'masters'){
        return false;
      }
      return true;
    },
    showDisableButton(){
      if (this.resourceName !== 'masters'){
        return false;
      }
      return true;
    },
    showDeleteButton(){
      if (['message', 'requests', 'news', 'reminders', 'reminder_histories', 'questionnaires', 'answers'].indexOf(this.resourceName) !== -1) {
        return false;
      }

      return true;
    },
    showRestoreButton(){
      if (['maker_administrators', 'makers'].indexOf(this.resourceName) < 0) {
        return false;
      }

      return true;
    },
    showUnshippedButton(){
      if (this.resourceName === 'requests'){
        return true;
      }

      return false;
    },
    showAutoReplyDialog(){
      if(this.resourceName === 'message'){
        return true;
      }

      return false;
    },
    isHiddenPagination() {
      if (this.resourceName === 'answers') {
        // ページャーの高さを確保しつつ非表示にするためのclassを付与
        return true;
      }
      return false;
    },
    optionName() {
      return (optionName, value) => {
        const options =
          this.$store.getters[`${optionName}/options/options`] || [];
        return (options.find(v => v.value === value) || {}).label;
      };
    },
    condiments() {
      return this.$store.getters["recipes/list/condiments"];
    },
    isProvider() {
      return this.$store.getters[`auth/isProvider`];
    },
    selected() {
      return this.$store.getters[`${this.resourceName}/list/selected`] || [];
    },
    allSelected() {
      return this.$store.getters[`${this.resourceName}/list/allSelected`];
    },
    tabIndex() {
      return this.$store.getters[`${this.resourceName}/list/tabIndex`];
    }
  },
  watch: {
    shouldFetch(should) {
      if (should) {
        this.fetch(this.currentPage)
          .then(() => {
            this.$store.commit("filters/fetched");
          })
          .catch(() => {
            this.$store.commit("filters/fetched");
          });
      }
    },
    tabIndex(value) {
      this.$store.commit(`${this.resourceName}/list/initialize`);
      this.$store.dispatch("filters/initialize");
      this.updateSelected([]);
      this.updateAllSelected(false);
      this.fetch(1);
    }
  },
  methods: {
    fetch(page) {
      let params = {
        page,
        filters: this.filters,
        sort: this.sort
      };

      params = this.addExtraParams(params);

      if (this.resourceName === 'answers') {
        const id = this.$route.params.pk;
        return this.$store.dispatch(`${this.resourceName}/list/indexQuestions`, { id: id });
      }
      else if(this.resourceName === 'reminder_histories'){
        return this.$store.dispatch(`${this.resourceName}/list/histories`, {
          id: this.subId,
          ...params
        });
      }
      else {
        return this.$store.dispatch(`${this.resourceName}/list/index`, params);
      }
    },
    onRefresh() {
      this.fetch(this.currentPage);
    },
    onFilter() {
      this.$store.commit("filters/open");
    },
    moveToCreate() {
      let path = `/${this.resourceName}/create`;

      // if (this.resourceName === "users") {
      //   path = `/${this.resourceName}/create-basic`;
      //   this.$store.commit(`${this.resourceName}/entity/initialize`);
      // }
      if (this.resourceName === 'masters' || this.resourceName === 'push_advertisments') {
        this.$store.commit(`${this.resourceName}/entity/open`, {pk: null});
      } else {
        this.$router.push({path});
      }
    },
    moveToShow(item) {
      if (this.resourceName === 'inquiries' || this.resourceName === 'masters') {
        this.$store.commit(`${this.resourceName}/entity/open`, {pk: item[this.pk]});
      } else if (this.resourceName === 'answers') {
        if (item.answer_method === 1) {
          this.$router.push({
            path: `/${this.resourceName}/${this.subId}/${this.$route.params.pk}/${item[this.pk]}`
          });
        }
      } else if (this.resourceName === 'push_advertisments') {
        return;
      } else {
        this.$router.push({
          path: `/${this.resourceName}/${item[this.pk]}`
        });
      }
    },
    moveToShowStatistics(item) {
      this.$router.push({
        path: `/${this.resourceName}/${this.subId}/${this.$route.params.pk}/${item[this.pk]}`
      });
    },
    openRequestDetail(item){
      this.$router.push({
        path: `/${this.resourceName}/${item[this.pk]}`
      });
    },
    openEditFreeText(item) {
      this.$store.commit(`${this.resourceName}/entity/openFreeText`, {pk: item[this.pk]});
    },
    onShipped() {
      utility
        .$confirm("出荷完了にしてよろしいですか？", "確認", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "success",
          center: true
        })
        .then(() => {
          this.$store
            .dispatch(`${this.resourceName}/list/shipped`, {
              ids: this.selected.map(item => { return item[this.pk]})
            })
            .then(() => {
              this.fetch(this.currentPage);
            });
        })
        .catch(() => {
        });
    },
    onRemoveShipped() {
      utility
        .$confirm("出荷済み状態を取り消してよろしいですか？", "確認", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "success",
          center: true
        })
        .then(() => {
          this.$store
            .dispatch(`${this.resourceName}/list/removeShipped`, {
              ids: this.selected.map(item => { return item[this.pk]})
            })
            .then(() => {
              this.fetch(this.currentPage);
            });
        })
        .catch(() => {
        });
    },
    onOngoingInquiryButton() {
      utility
        .$confirm("対応中のステータスに更新しますか", "確認", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "success",
          center: true
        })
        .then(() => {
          this.$store
            .dispatch(`${this.resourceName}/list/ongoing`, {
              ids: this.selected.map(item => { return item[this.pk]})
            })
            .then(() => {
              this.fetch(this.currentPage);
            });
        })
        .catch(() => {
        });
    },
    onCompleteInquiryButton() {
      utility
        .$confirm("対応済のステータスに更新しますか", "確認", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "success",
          center: true
        })
        .then(() => {
          this.$store
            .dispatch(`${this.resourceName}/list/complete`, {
              ids: this.selected.map(item => { return item[this.pk]})
            })
            .then(() => {
              this.fetch(this.currentPage);
            });
        })
        .catch(() => {
        });
    },
    enable() {
      let message = "有効にしますか？";

      utility
        .$confirm(message, "確認", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true
        })
        .then(() => {
          this.$store
            .dispatch(`${this.resourceName}/list/enable`, {
              ids: this.selected.map(item => { return item[this.pk]})
            })
            .then(() => {
              this.fetch(this.currentPage);
              this.updateSelected([]);
              this.updateAllSelected(false);
            });
        })
        .catch(() => {
        });
    },
    disable() {
      let message = "無効にしますか？";

      utility
        .$confirm(message, "確認", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true
        })
        .then(() => {
          this.$store
            .dispatch(`${this.resourceName}/list/disable`, {
              ids: this.selected.map(item => { return item[this.pk]})
            })
            .then(() => {
              this.fetch(this.currentPage);
              this.updateSelected([]);
              this.updateAllSelected(false);
            });
        })
        .catch(() => {
        });
    },
    remove() {
      if (this.resourceName === 'users' && this.isProvider && !this.$store.getters["auth/permissionUserEdit"]) {
        utility
          .$alert("編集権限がありません。", "エラー", {
            confirmButtonText: "OK",
            type: "error",
            center: true
          })
          .then(() => {
          });
      } else {
        let message = "削除しますか？";
        if(this.resourceName === 'requests'){
          message = "出荷キャンセルにしてよろしいですか？";
        }
        if(this.resourceName === 'products'){
          if(this.selected.some((item) => {
            return item.recipe_id !== null;
          })){
            message = "公開中の紐付きレシピがありますがよろしいですか？";
          }
        }

        utility
          .$confirm(message, "確認", {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning",
            center: true
          })
          .then(() => {
            this.$store
              .dispatch(`${this.resourceName}/list/destroy`, {
                ids: this.selected.map(item => { return item[this.pk]})
              })
              .then(() => {
                this.fetch(this.currentPage);
                this.updateSelected([]);
                this.updateAllSelected(false);
              });
          })
          .catch(() => {
          });
      }
    },
    restore() {
      this.$store
        .dispatch(`${this.resourceName}/entity/restore`, {
          ids: this.selected.map(item => {
            return item[this.pk]
          })
        })
        .then(() => {
          this.fetch(this.currentPage);
          this.updateSelected([]);
          this.updateAllSelected(false);
        });
    },
    publish(status) {
      this.publishModal = false;
      this.unPublishModal = false;
      this.$store
        .dispatch(`${this.resourceName}/list/publish`, {
          ids: this.selected.map(item => { return item[this.pk]}),
          status,
          reserve: this.reservePublish,
          date: this.targetDate != null ? moment(this.targetDate).format('YYYY-MM-DD') : null,
          makerIds: this.selected.map(item => { return item['maker_id']})
        })
        .then(() => {
          this.fetch(this.currentPage);
          this.updateSelected([]);
          this.updateAllSelected(false);
        });
    },
    cancelPublish() {
      this.$store
        .dispatch(`${this.resourceName}/list/cancelPublish`, {
          ids: this.selected.map(item => { return item[this.pk]})
        })
        .then(() => {
          this.fetch(this.currentPage);
          this.updateSelected([]);
          this.updateAllSelected(false);
        });
    },
    resetPassword(item) {
      this.$store.commit("passwordReissue/open", {row: item});
    },
    onChangePage(page, reduced) {
      this.fetch(page);
    },
    onChangePerPage(perPage) {
      this.$store.dispatch(`${this.resourceName}/list/changePerPage`, {
        perPage
      });
      this.fetch(1);
    },
    onHeaderClick(columnClicked) {
      if (columnClicked.property === "buttons") {
        return;
      }

      const column = this.columns.find(
        column => column.name === columnClicked.property
      );

      if (!column.sortable) {
        return;
      }

      this.$store.commit(`${this.resourceName}/list/setSort`, {
        field: columnClicked.property,
        type: column.type || ""
      });

      this.fetch(this.currentPage);
    },
    sortBy(options) {
      const {column, asc} = options;

      if (column.length) {
        const field = column;
        const direction = asc ? "asc" : "desc";
        const target = this.columnsForTable.find(v => v.value === field) || {};
        const {type, sortable} = target;

        if (sortable === false) {
          return;
        }

        this.$store.commit(`${this.resourceName}/list/setSort`, {
          field,
          type,
          direction
        });

        this.fetch(this.currentPage);
      }
    },
    getRowStyle(header) {
      return {
        diplay: "block",
        width: header.width + "px"
      };
    },
    onCheck(row) {
      const index  = this.selected.findIndex(item => item[this.pk] === row[this.pk]);
      if(index >= 0){
        let sliced = this.selected.slice(0, this.selected.length);
        sliced.splice(index, 1);
        this.updateSelected(sliced);
      } else {
        this.updateSelected([
          row,
          ...this.selected
        ])
      }
    },
    selectAll(){
      if(this.allSelected){
        this.updateSelected([]);
        this.updateAllSelected(false);
      }
      else {
        this.updateSelected(this.entities.map(item => {
          return item
        }));
        this.updateAllSelected(true);
      }
    },
    onChangeReservePublish(value, obj){
      this.reservePublish = value;
    },
    openAutoReplyDialog() {
      this.$store.commit(`${this.resourceName}/list/open`);
    },
    openCondimentsModal(recipe_id) {
      this.$store.dispatch(`${this.resourceName}/list/condiments`, {recipe_id})
        .then(() => {
          this.condimentsModal = true;
        });
    },
    openConditionsModal(push_advertisments_id) {
      this.$store.commit(`${this.resourceName}/entity/openConditions`, {pk: push_advertisments_id});
    },
    openPublishModal(){
      this.publishModal = true;
      this.targetDate = null;
    },
    openUnPublishModal(){
      this.unPublishModal = true;
      this.targetDate = null;
    },
    onChangePassword() {
      this.$store.commit("passwordReissue/open", {id: null});
    },
    statusName(value) {
      if (this.resourceName === 'inquiries') {
        switch (value) {
          case 0:
            return "";
          case 1:
            return "対応中";
          case 2:
            return "済";
          default:
            return "";
        }
      } else if (this.resourceName === 'masters') {
        if (value === 0) {
          return "有効";
        } else {
          return "無効";
        }
      } else {
        switch (value) {
          case 1:
            return "サンプル依頼受け";
          case 2:
            return "出荷完了";
          case 3:
            return "レビュー受領";
          case 4:
            return "出荷キャンセル";
          default:
            return "";
        }
      };

      return "";
    },
    userStatusName(value) {
      switch (value) {
        case 0:
          return "";
        case 1:
          return "退会";
        case 2:
          return "削除";
        default:
          return "";
      }
    },
    inquiryTypeName(value) {
      switch (value) {
        case 1:
          return "通報";
        case 2:
          return "システム障害";
        case 3:
          return "操作方法";
        case 4:
          return "ユーザー関連";
        case 5:
          return "その他";
        default:
          return "";
      }
    },
    openDialog(resource) {
      this.$store.commit(`import_${resource}/csv/open`);
    },
    openMainFlgDialog() {
      this.$store.commit("masters/list/mainFlgOpen");
    },
    updateSelected(selected) {
      return this.$store.commit(`${this.resourceName}/list/updateSelected`, {selected});
    },
    updateAllSelected(allSelected) {
      return this.$store.commit(`${this.resourceName}/list/updateAllSelected`, {allSelected});
    },
    showCheckBox(item) {
      if (this.resourceName === 'templates') {
        // デフォルトのレビューセットはチェックボックスを非表示
        return item.type !== '1';
      }
      return true;
    },
    showStatisticsButton(item) {
      if (this.resourceName !== 'answers') {
        return false;
      }
      if (item.answer_method === 2 || item.answer_method === 3) {
        return true;
      }
      return false;
    },
    moveToDownload(name) {
      if(this.isProvider){
        this.$router.push({path: `/download_${name}`});
      }else {
        this.$router.push({path: `/download_${name}/${this.$store.getters[`auth/makerId`]}`});
      }
    },
    moveToNews() {
      this.$router.push({
        path: `/news`
      });
    },
    moveToReminders() {
      this.$router.push({
        path: `/reminders`
      });
    },
    activeTab(tabIndex) {
      this.$store.dispatch(`${this.resourceName}/list/updateTabIndex`, { value: tabIndex });
    },
    addExtraParams(params) {
      if (this.resourceName === 'inquiries') {
        const tabIndex = this.$store.getters[`${this.resourceName}/list/tabIndex`];
        params.extra = {
          inquiry_type: tabIndex === 0 ? 1 : 2
        };
      }

      return params;
    },
    afterDialogSaved() {
      this.fetch(1);
    },
    downloadCSV() {
      utility
        .$confirm("CSVをダウンロードしますか？", "確認", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true
        })
        .then(() => {
          this.$store
            .dispatch(`${this.resourceName}/list/downloadCSV`, { id: this.$route.params.pk, productId: this.subId })
            .then(() => {
            });
        })
        .catch(() => {
        });
    },
    openSendTargetModal(notification_id) {
      console.log(notification_id);
      this.$store.commit(`reminders/entity/open`, {pk: notification_id});
    },
  },
  created() {
    if(this.resourceName !== 'reminder_histories') {
      this.$store.commit(`${this.resourceName}/entity/initialize`);
    }

    this.fetch(1);
  }
};
</script>

<style module lang="scss">
$base-app-header-height: 75px;
$base-app-tab-height: 40px;
$base-index-header-height: 60px;
$base-index-footer-height: 60px;

.container {
  width: 100%;
  height: calc(100% - #{$base-app-header-height});
  padding: 0;
  position: relative;
  background-color: #fff;

  .container-content {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    height: calc(100% - #{$base-index-header-height});

    .main-tab-content {
      height: calc(100vh - #{$base-index-header-height} - #{$base-index-footer-height} - #{$base-app-tab-height}) !important;
    }
    .main-content,
    .main-tab-content {
      display: flex;
      position: relative;
      flex-direction: column;
      height: calc(
        100vh - #{$base-index-header-height} - #{$base-index-footer-height}
      );

      :global(.v-data-table.v-data-table--fixed-header) {
        width: 100%;
        position: relative;
        height: calc(
          100vh - #{$base-index-header-height} - #{$base-index-footer-height}
        );

        :global(.v-data-table__wrapper) {
          height: 100%;
        }
      }

      th > div{
        width: max-content;
      }

      input[type=checkbox] {
        width:			16px;
        height:			16px;
        -moz-transform:		scale(1.15);
        -webkit-transform:	scale(1.15);
        transform:		scale(1.15);
      }
    }
  }

  .container-footer{
    background-color: #fff;
  }

  .pagination {
    height: $base-index-footer-height !important;
  }
}

.control-button{
  width: 60px !important;
}
.control-button-wide {
  width: 120px !important;
}
.control-button-extra-wide {
  width: 150px !important;
}

.toolbar-total {
  position: absolute;
  right: 300px;
}

.datepicker{
  div > input{
    border: 1px ridge #333333;
    display: block;
    margin: 5px 5px 10px;
  }
}

.main-table {
  font-size: 13px !important;
  height: 100%;
  > div {
    height: 100%;
  }
}
</style>
<style lang="scss">
  select{
    -moz-appearance: auto !important;
    -webkit-appearance: auto !important;
  }

  .form-check-input {
    width: 15px;
    height: 15px;
  }

  .text-bold {
    font-weight: bold !important;
  }
</style>
<style lang="scss">
.nav-tabs {
  .nav-item {
    .nav-link {
      color: #123457 !important;
    }
  }
}
</style>
<style scoped lang="scss">
.hidden-pagination {
  visibility: hidden;
}
</style>